import type { CourseDefinition } from '../types'

export const COURSES: CourseDefinition[] = [
  {
    id: 'investing-essentials',
    number: 1,
    title: 'Investing Essentials',
    eyebrow: 'Start here',
    description: 'Why investing works, how risk behaves, how markets operate, and what cash, bonds, stocks, funds, and alternative investments actually do.',
    preview: 'Foundations · Asset classes · Costs · Funds · Alternatives',
    color: '#2463d4',
    softColor: '#eaf1ff',
    firstModule: 1,
    lastModule: 17,
  },
  {
    id: 'money-life-planning',
    number: 2,
    title: 'Money & Life Planning',
    eyebrow: 'Build your base',
    description: 'Cash flow, emergency savings, debt, credit, benefits, insurance, goals, risk capacity, life stages, families, and a written plan.',
    preview: 'Financial base · Protection · Goals · Family context',
    color: '#067a70', // darkened from #07877c so white and tinted labels meet WCAG AA 4.5:1
    softColor: '#e2f6f2',
    firstModule: 18,
    lastModule: 28,
  },
  {
    id: 'taxes-accounts',
    number: 3,
    title: 'Taxes & Accounts',
    eyebrow: 'Keep more',
    description: 'Income, investment and state taxes, retirement accounts, Roth decisions, HSAs, education accounts, asset location, harvesting, giving, and withdrawals.',
    preview: 'Tax basics · 401(k)s · IRAs · Roth · Account strategy',
    color: '#7040c9',
    softColor: '#f1eaff',
    firstModule: 29,
    lastModule: 42,
  },
  {
    id: 'strategies-portfolios',
    number: 4,
    title: 'Strategies & Portfolio Management',
    eyebrow: 'Build and manage',
    description: 'Indexing and active approaches, styles and factors, allocation models, portfolio construction, rebalancing, performance, behavior, and fraud protection.',
    preview: 'Competing views · Portfolio design · Monitoring · Behavior',
    color: '#9a6211', // darkened from #ad6f13 so white and tinted labels meet WCAG AA 4.5:1
    softColor: '#fff3dc',
    firstModule: 43,
    lastModule: 62,
  },
  {
    id: 'real-estate',
    number: 5,
    title: 'Real Estate Investing',
    eyebrow: 'Property',
    description: 'Rent versus buy, mortgages, rental analysis, leverage, operations, state landlord rules, tax rules, REITs, syndications, and comparison with securities.',
    preview: 'Home decisions · Rentals · Financing · Taxes · REITs',
    color: '#b33c32',
    softColor: '#ffebe8',
    firstModule: 63,
    lastModule: 71,
  },
  {
    id: 'retirement',
    number: 6,
    title: 'Financial Independence & Retirement',
    eyebrow: 'Independence',
    description: 'FI and FIRE, retirement targets, withdrawal systems, sequence risk, Social Security, Medicare, pensions, RMDs, annuities, and long-term care.',
    preview: 'FI math · Retirement income · Benefits · Health care',
    color: '#087443',
    softColor: '#e4f6ea',
    firstModule: 72,
    lastModule: 83,
  },
  {
    id: 'estate-life-events',
    number: 7,
    title: 'Estate, Legacy & Life Changes',
    eyebrow: 'Protect people',
    description: 'Documents, beneficiaries, trusts, federal and state taxes, giving, marriage, children, aging parents, widowhood, career changes, and special-needs planning.',
    preview: 'Estate planning · Wealth transfer · Family transitions',
    color: '#98418c',
    softColor: '#faeafb',
    firstModule: 84,
    lastModule: 102,
  },
  {
    id: 'advice-plans',
    number: 8,
    title: 'Advice & Complete Plans',
    eyebrow: 'Put it together',
    description: 'Choose an advisor or platform intelligently, then see the course applied to six different households—including an age-gap family planning lifetime support.',
    preview: 'Advisors · Platforms · Six contextual plans',
    color: '#335c81',
    softColor: '#e8f0f7',
    firstModule: 103,
    lastModule: 105,
  },
]

export function courseForModule(moduleNumber: number): CourseDefinition {
  const course = COURSES.find((item) => moduleNumber >= item.firstModule && moduleNumber <= item.lastModule)
  if (!course) throw new Error(`No course contains module ${moduleNumber}.`)
  return course
}
